export const MenusPersonnages = () => {
    const datas = [
        { name: 'Rendez-vous', href: '/rendez-vous' },
        { name: 'Personnages des parcs', href: '/personnages' },
    ];
    return datas;
}